import React, { useState, useEffect, useContext } from 'react';
import styles from './styles.module.scss';
import Select from 'react-select';
import PaymentsStore from 'src/stores/PaymentsStore';
import { observer } from 'mobx-react';
import { styleSelectComponent } from 'src/utils';
import useIsOptionsLoading from 'src/utils/hooks/useIsOptionsLoading';

export interface PaymentGatewayTypeDropDownProps {
    onChange: Function;
    selectedValue?: number | string;
}

function PaymentGatewayTypeDropDown(props: PaymentGatewayTypeDropDownProps) {
    const paymentsStore = useContext(PaymentsStore);
    const options = paymentsStore.paymentGatewayTypesDropDownValues;
    const [selected, setSelected] = useState(options.find((i) => i.value === props.selectedValue) || null);
    const isLoading = useIsOptionsLoading(options);

    useEffect(() => {
        paymentsStore.getPaymentGatewayTypes();
    }, []);

    useEffect(() => {
        const selectedVal = options.find((i) => i.value === props.selectedValue);
        if (selectedVal) {
            setSelected(selectedVal);
        }
    }, [props.selectedValue, options]);

    return (
        <Select
            value={selected}
            onChange={(s: any) => {
                setSelected(s);
                props.onChange(s || null);
            }}
            isLoading={isLoading}
            className={styles.select}
            options={options}
            placeholder="Select Gateway"
            styles={styleSelectComponent()}
        />
    );
}

export default observer(PaymentGatewayTypeDropDown);
